import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useApp } from "../App";

export default function Profile() {
  const { user, t, handleSignOut } = useApp();
  const [whatsapp, setWhatsapp] = useState("");
  const [savedWhatsapp, setSavedWhatsapp] = useState("");
  const [savingWhatsapp, setSavingWhatsapp] = useState(false);
  const [whatsappSaved, setWhatsappSaved] = useState(false);
  const [showHowItWorks, setShowHowItWorks] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user) return;
      const snap = await getDoc(doc(db, "users", user.uid));
      if (snap.exists()) {
        const num = snap.data().whatsapp || "";
        setWhatsapp(num);
        setSavedWhatsapp(num);
      }
    };
    fetchProfile();
  }, [user]);

  const handleSaveWhatsapp = async () => {
    setSavingWhatsapp(true);
    await updateDoc(doc(db, "users", user.uid), { whatsapp });
    setSavedWhatsapp(whatsapp);
    setSavingWhatsapp(false);
    setWhatsappSaved(true);
    setTimeout(() => setWhatsappSaved(false), 2000);
  };

  const initials = (user?.displayName || "?")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="profile-page">
      {/* Header */}
      <div className="profile-header">
        <div className="profile-avatar">{initials}</div>
        <div>
          <div className="profile-name">{user?.displayName}</div>
          <div className="profile-email">{user?.email}</div>
        </div>
      </div>

      <div className="profile-body">

        {/* WhatsApp */}
        <div className="profile-section">
          <div className="profile-section-title">{t.whatsappNumber}</div>
          <div className="whatsapp-row">
            <div className="whatsapp-input-row">
              <input
                className="whatsapp-input"
                type="tel"
                placeholder={t.whatsappPlaceholder}
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
              />
              <button
                className="whatsapp-save-btn"
                onClick={handleSaveWhatsapp}
                disabled={savingWhatsapp || whatsapp === savedWhatsapp}
              >
                {whatsappSaved ? "Saved ✓" : t.saveNumber}
              </button>
            </div>
            <div style={{ fontSize: 12, color: "var(--text-tertiary)", lineHeight: 1.5 }}>
              Your number is shared with buyers when they contact you. Include your country code, e.g. +351 912 345 678.
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="profile-section">
          <div className="profile-section-title">About</div>
          <button
            className="profile-row"
            onClick={() => setShowHowItWorks(!showHowItWorks)}
          >
            <span>{t.howItWorks}</span>
            <span style={{ color: "var(--text-tertiary)", fontSize: 18 }}>
              {showHowItWorks ? "−" : "+"}
            </span>
          </button>
          {showHowItWorks && (
            <div className="expand-content">{t.howItWorksText}</div>
          )}
          <button
            className="profile-row"
            onClick={() => setShowPrivacy(!showPrivacy)}
          >
            <span>{t.privacy}</span>
            <span style={{ color: "var(--text-tertiary)", fontSize: 18 }}>
              {showPrivacy ? "−" : "+"}
            </span>
          </button>
          {showPrivacy && (
            <div className="expand-content">{t.privacyText}</div>
          )}
          <button
            className="profile-row"
            onClick={() => window.open("mailto:hello@kepti.app", "_blank")}
          >
            <span>{t.contactModerator}</span>
            <span style={{ color: "var(--text-tertiary)" }}>→</span>
          </button>
        </div>

        {/* Also on kepti */}
        <div className="profile-section">
          <div className="profile-section-title">Also from kepti</div>
          <button
            className="profile-row"
            onClick={() => window.open("https://kepti.app", "_blank")}
          >
            <span>kepti — school uniform exchange</span>
            <span style={{ color: "var(--text-tertiary)" }}>→</span>
          </button>
        </div>

        {/* Sign out */}
        <div className="profile-section">
          <button className="profile-row danger" onClick={handleSignOut}>
            {t.signOut}
          </button>
        </div>

        <div style={{
          textAlign: "center",
          fontSize: 12,
          color: "var(--text-tertiary)",
          paddingTop: 8,
          paddingBottom: 16,
        }}>
          kepti market · Pass it on.
        </div>

      </div>
    </div>
  );
}
